import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ApplicationsAccessLayout } from 'pages/settings/pages/developer/pages/applications/layout/ApplicationsAccessLayout'
import { ApplicationsPageLayout } from 'pages/settings/pages/developer/pages/applications/layout/ApplicationsPageLayout'
import { ApplicationsPage } from 'pages/settings/pages/developer/pages/applications/ui/applicationsPage'

export const ApplicationsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<ApplicationsAccessLayout />}>
        <Route element={<ApplicationsPageLayout />}>
          <Route path={'/'} element={<ApplicationsPage />} />
        </Route>
      </Route>
    </Routes>
  )
})
